import { Injectable } from '@angular/core';
// import { JwtHelperService } from '@auth0/angular-jwt';
@Injectable()
export class AuthService {
  // public jwtHelper: JwtHelperService
  constructor() { }
  // ...
  public isAuthenticated(): boolean {
    if (localStorage.getItem('internallogin')) {
      return true;
    } else {
      return false;
    }
    // const token = localStorage.getItem('token');
    // Check whether the token is expired and return
    // true or false
    // return !this.jwtHelper.isTokenExpired(token);
  }
}
